// import components
import { styled } from '@mui/material';
import { DataGridPro, GridValidRowModel } from '@mui/x-data-grid-pro';
import { StyledDataGridProStyleProps } from './DataGrid.types';

export const StyledDataGridPro = styled(DataGridPro<GridValidRowModel>, {
  shouldForwardProp: (prop) => prop !== 'tableBgColor'
})<StyledDataGridProStyleProps>(({ theme, tableBgColor }) => ({
  backgroundColor: tableBgColor,

  '& .MuiDataGrid-columnHeaders .MuiDataGrid-columnHeader, .MuiDataGrid-columnHeaders .MuiDataGrid-scrollbarFiller':
    {
      backgroundColor: theme.vars.palette.common.white
    },

  '& .stripedRow-even': {
    backgroundColor: theme.vars.palette.grey[100],

    '&:hover': {
      backgroundColor: theme.vars.palette.surface.containerHigh
    }
  },

  '& .stripedRow-odd': {
    '&:hover': {
      backgroundColor: theme.vars.palette.surface.containerHigh
    }
  },

  '& .MuiDataGrid-row:not(.Mui-selected)': {
    '&.highlighted-row': {
      backgroundColor: theme.vars.palette.Alert.warningStandardBg
    }
  },

  '& .dg-hide-checkbox .MuiDataGrid-cellCheckbox > *': {
    display: 'none'
  }
}));
